export default "__VITE_ASSET__BFH5SKj9__"